module.exports = __webpack_public_path__ + "media/images/gallery-image8-14cb5277a2ae910665c339af9bcd84e8.webp";